export default __webpack_public_path__ + "static/media/Datchik-otkrytiya-i-zakrytiya_about.c9a0caff.webp";